import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>Atención médica primaria</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography m={3}>
            <ol>
              <li>
              Consulta medicina general, curaciones atención de primer contacto.
              </li>
            </ol>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>Exámenes médicos</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography m={3}>
            <ul>
              <ol>
                <li>Por perfil de puesto de trabajo y de acuerdo al tipo de exposición y riesgo ocupacional.</li>
                <li>Exámenes médicos de reingreso o recontratación después de una incapacidad. </li>
              </ol>
            </ul>
          
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>Campañas de salud </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography  m={3}>
          Campañas de prevención de enfermedades crónico degenerativas como: diabetes, hipertensión arterial, obesidad etc.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <Typography>Campañas de seguridad</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography  m={3}>
          Cuidado de manos, trabajo en alturas, manejo de cargas manuales, etc.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
          <Typography>Implementación de normativas</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography  m={3}>
          Se tiene contacto con medicina del trabajo en IMSS para aplicacion del programa ELSA cumpliendo las normas oficiales y ahorrando en proveedores externos.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
          <Typography>Inspección</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography  m={3}>
            <ul>
              <ol>
                <li>
                Inspección de instalaciones y asesoría para mejorar seguridad en sucursales, y manejo de material en la empresa para disminución de accidentes de tipo laboral.
                </li>
                <li>
                Supervisión del cumplimiento del programa de trabajo anual por parte del medico de la empresa.
                </li>
              </ol>
            </ul>
         </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}